import type { NonBetaLocale } from '@change-corgi/config/locales';

import __help from '../config/help.json';

import type { HELP_LOCALES } from './consts';

export type HelpLocale = (typeof HELP_LOCALES)[number];

export const helpLocales = __help.localeMapping as unknown as Record<NonBetaLocale, HelpLocale>;

export const helpCountryLegalHelpUrls: Partial<Record<string, string>> = __help.legalHelpUrls;

export const helpCountryLegalUrls: Partial<Record<string, string>> = __help.legalUrls;

export const helpLocaleAccessibilityStatementUrls = __help.accessibilityStatementUrls as unknown as Record<
	HelpLocale,
	string
>;
